import { useState, useEffect, DependencyList } from 'react';
import { useAppContext } from './useAppContext';

/**
 * An effect that always runs atleast once on the server,
 * but behaves normally on the client side
 * @param effect function returning promise
 * @param dependencies  list of dependencies like in useEffect
 */
export const useSSE = function <T>(
    effect: () => Promise<T>,
    dependencies?: DependencyList
): (T | null | unknown)[] {
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState<Error | null>(null);
    const { isSSR } = useAppContext();

    if (isSSR && typeof window === 'undefined') {
        try {
            effect()
                .then((res) => {
                    setData(res as T);
                })
                .catch((error) => {
                    setError(error);
                });
        } catch (err: any) {
            setError(err);
        }
    }

    useEffect(() => {
        try {
            effect()
                .then((res) => {
                    setData(res as T);
                })
                .catch((error) => {
                    setError(error);
                });
        } catch (err: any) {
            setError(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);

    return [data, error];
};
